import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const navItems = [
    {
      navName: "Investor Relations",
      navLink: "#",
      id: "investorRelation",
    },
    {
      navName: "Add Retaurant",
      navLink: "#",
      id: "add Retaurant",
    },
    {
      navName: "Log in",
      navLink: "/login",
      id: "mloginLink",
    },
    {
      navName: "Sign up",
      navLink: "/register",
      id: "msignupLink",
    },
  ];
  return (
    <div className="position-fixed w-100 navMobileMain">
      <nav className="navbar navbar-expand-lg bg-transparent">
        <div className="container text-white">
          <Link
            className="navbar-brand fw-semibold text-white"
            style={{ fontSize: "13px" }}
            to={"/"}
          >
            Get The App
          </Link>
          <button
            className="navbar-toggler mobileHeaderMain"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav nav-main ms-auto mb-2 mb-lg-0 fw-semibold">
              {navItems.map((navItems) => {
                return (
                  <li className="nav-item ms-4" key={navItems.id}>
                    <Link
                      className="nav-link active text-white"
                      aria-current="page"
                      to={navItems.navLink}
                      id={navItems.id}
                    >
                      {navItems.navName}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
